export default {
  resource: "user",
  map() {
    this.route("circles", function () {
      this.route("type", { path: "/:type_id" });
    });
  },
};
